<template>
  <div class="CaseArticlePhonePage">
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="article-box">
      <div class="titleName">
        <span>{{ articleShow.title }}</span>
        <span
          id="titleTag"
          :style="{
            color: getColor(articleShow.shortTitle).color,
            background: getColor(articleShow.shortTitle).background,
          }"
          >{{ articleShow.shortTitle }}</span
        >
      </div>
    </div>
    <div v-html="articleContent" class="titleContent"></div>
    <!-- 相关案例 -->
    <div class="swipe-box">
      <div class="swipe-title">相关案例</div>
      <div class="swipe-list">
        <van-swipe class="swipe-case" :width="300" :loop="false">
          <van-swipe-item
            v-for="item in articleBox"
            :key="item.id"
          >
            <div class="swipe-item customArticle" >
              <router-link
                :to="{
                  path: '/CasePhonePage/CasePhonePageArticle',
                  query: {
                    id: item.id,
                  },
                }"
              >
                <div class="customImg">
                  <img
                    :src="'http://www.jxdinfo.com' + item.typeImg"
                    style="width: 100%"
                  />
                </div>
                <div class="customArticleTitle">
                  {{ item.title }}
                  <span
                    :style="{
                      color: getColor(item.shortTitle).color,
                      background: getColor(item.shortTitle).background,
                    }"
                    >{{ item.shortTitle }}</span
                  >
                </div>
                <div class="customArticleDesc">{{ item.description }}</div>
              </router-link>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <RightMenu
      :isMenuShow="isMenuShow"
      @rightMenuShow="handleRightMenuShow"
    ></RightMenu>
    <!-- 底部立即体验弹出 -->
    <ExperienceNow
      :isPopShow="isPopShow"
      @CloseExperienceNow="handleCloseExperienceNow"
    ></ExperienceNow>
    <!-- 公司信息 -->
    <CompanyInformation
      @changePracticeMenuShow="handleOpenPractice"
    ></CompanyInformation>
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>

<script>
import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import RightMenu from "./include/RightMenu";
import ExperienceNow from "./include/ExperienceNow";
import CompanyInformation from "./include/CompanyInformation";
import { getArticleContent,getContentViewById , getCustomCase } from "../api/casePage";
export default {
  name: "CasePhonePageArticle",
  components: {
    PhoneHeader,
    PhoneFooter,
    RightMenu,
    ExperienceNow,
    CompanyInformation,
  },
  props: {},
  data() {
    return {
      isPopShow: false, // 立即体验弹窗
      isMenuShow: false, // 顶部菜单栏
      article: [],
      articleBox: [],
      articleShow: [],
      articleData: {
        channelId: 287,
        pageNo: 1,
        pageSize: 8,
      },
      articleContent: "",
      colorList: [
        {
          name: "航天航空",
          color: "#2682FF",
          background: "#D2E5FF",
        },
        {
          name: "电力",
          color: "#EC9C23",
          background: "#FFE8C5",
        },
        {
          name: "智能制造",
          color: "#374AEC",
          background: "#D1D6FC",
        },
        {
          name: "建筑工程",
          color: "#7909CE",
          background: "#E9D1FC",
        },
        {
          name: "证券金融",
          color: "#BEB101",
          background: "#FFFBC5",
        },
        {
          name: "通信",
          color: "#E93636",
          background: "#FED2D2",
        },
        {
          name: "能源",
          color: "#009F2A",
          background: "#CBF8D7",
        },
        {
          name: "轨道交通",
          color: "#00A2DF",
          background: "#D2F3FF",
        },
        {
          name: "石化",
          color: "#308805",
          background: "#DAF8CB",
        },
        {
          name:'有色金属',
          color:'#7909CE',
          background:'#E9D1FC',
        },
        {
          name:'金属冶炼',
          color:'#EFA83E',
          background:'#FFE8C5',
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      this.refresh()
    }
  },
  methods: {
    refresh() {
      window.location.reload();
    },
    // 打开右侧菜单弹窗
    handleMenu() {
      this.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      this.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      this.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow() {
      this.isPopShow = false;
    },
    // 获取文章
    getCustomCase() {
      const self = this;
      getCustomCase(self.articleData)
        .then((res) => {
          res.data.content.reverse();
          self.article = res.data.content;
          for (let i = 0; i < self.article.length; i++) {
            if (self.article[i].id === self.$route.query.id) {
              self.articleShow = self.article[i];
              break;
            }
          }
          const tempArticle = [];
          for (let i = 0; i < self.article.length; i++) {
            if (self.article[i].id !== self.$route.query.id) {
              tempArticle.push(self.article[i]);
            }
          }
          const randomList = [];
          for (let i = 0; i < 4; i++) {
            let random = Math.floor(Math.random() * tempArticle.length);
            while (randomList.includes(random)) {
              random = Math.floor(Math.random() * tempArticle.length);
            }
            randomList.push(random);
            self.articleBox.push(tempArticle[random]);
          }
          self.articleBox = self.articleBox.reverse();
          self.articleTotal = res.data.total;
          self.getArticleContent();
        })
        .catch((error) => {
          self.$message.error("未获取到文章!");
        });
    },
    // 获取文章内容
    getArticleContent() {
      const self = this;
      getArticleContent(self.articleShow.id)
        .then((res) => {
          self.articleContent = res.data;
        })
        .catch((error) => {
          self.$message.error("未获取到文章内容!");
        });
      getContentViewById(self.articleShow.id).then((res) =>{

      }).catch((error) => {

      });
    },
    // 颜色
    getColor(name) {
      const self = this;
      let color = "";
      let background = "";
      for (let i = 0; i < self.colorList.length; i++) {
        if (self.colorList[i].name === name) {
          color = self.colorList[i].color;
          background = self.colorList[i].background;
          break;
        }
      }
      return {
        color,
        background,
      };
    },
  },
  mounted() {
    const self = this;
    // window.addEventListener("scroll", self.handleNavScroll);
    self.getCustomCase();
  },
};
</script>

<style scoped>
.article-box {
  margin-top: 53px;
  background: url("../assets/img/phoneCasePage/article-bg.png") no-repeat;
  background-size: cover;
  height: 130px;
}
.titleName {
  margin: 0 auto;
  font-size: 25px;
  font-weight: bold;
  color: #3e3a39;
  float: left;
  display: flex;
  align-items: center;
  padding: 25px 0px 0 20px;
}
.titleName span {
  text-align: center;
  width: 150px;
  border-left: 5px #186cf5 solid;
  display: inline-block;
}
.titleContent {
  min-height: 500px;
  margin-top: -70px;
  padding: 20px;
}
#titleTag {
  border: none;
  margin-left: -3px;
  font-size: 12px;
  border-radius: 5px;
  font-weight: normal;
  display: inline-block;
  width: 70px;
  height: 22px;
  text-align: center;
  line-height: 22px;
}

/* 相关案例 */
.swipe-box {
  height: 500px;
  background: #fff;
  /* background-image: linear-gradient(#125ee0, #7aaafd); */
  padding: 20px;
}
.swipe-title {
  display: flex;
  justify-content: center;
  font-size: 0.44rem;
  color: #000;
  font-weight: 600;
}

.swipe-list {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.swipe-case {
  height: 370px;
}
.swipe-case >>> .van-swipe__indicators .van-swipe__indicator {
  background: #333333;
}
.swipe-case >>> .van-swipe__indicator--active {
  background-color: #1989fa !important;
}
.swipe-item {
  height: 100%;
  width: 90%;
  /* padding: 20px 20px 10px 20px; */
  background-image: linear-gradient(to bottom, #fff, #e9f0ff);
  border-radius: 5px;
}
.van-swipe-item {
  display: flex;
  justify-content: center;
}
.swipe-item > img {
  height: 55px;
}
.swipe-item > .title {
  margin: 10px 0;
  font-size: 18px;
  font-weight: 600;
}
.swipe-item > .text {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}
/* 轮播图 */
.customArticle {
  width: 100%;
  height: 95%;
  box-shadow: 0px 0px 10px 1px rgba(0, 65, 178, 0.16);
  border-radius: 5px;
  float: left;
  margin: 10px 15px 50px;
}
.customImg {
  width: 100%;
  height: 180px;
  box-shadow: none;
}
.customImg img {
  width: 100%;
  height: 100%;
  border-radius: 5px 5px 0 0;
}
.customArticleTitle {
  margin: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #2e2e2e;
}
.customArticleTitle span {
  margin-left: 8px;
  font-size: 12px;
  border-radius: 5px;
  font-weight: normal;
  display: inline-block;
  padding: 0 10px;
  height: 22px;
  text-align: center;
  line-height: 22px;
}
.customArticleDesc {
  font-size: 14px;
  padding: 0 10px;
  width: 100%;
  height: 95px;
  color: #2e2e2e;
  line-height: 23px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/CasePhonePageArticle.vue